const handleTitle = (type) => {
    switch (type) {
        case 1:
            return 'Documento CRLV adicionado';
        default:
            break;
    }
};
const handleConter = (type, plate) => {
    switch (type) {
        case 1:
            return `Um documento CRLV foi adicionado para a placa ${plate || ''}`;
        default:
            break;
    }
};
export const notificationDtoToNotification = (GroupDto) => GroupDto.map(dto => ({
    chassi: dto.chassi,
    plate: dto.placa,
    id: dto.id,
    type: dto.tipoNotificacao,
    date: dto.ultimaAtualizacao,
    title: handleTitle(dto.tipoNotificacao),
    content: handleConter(dto.tipoNotificacao, dto.placa),
}));
